import React, { useState } from "react";
import WishlistList from "./WishlistList";
import { Link } from "react-router-dom";
import { WISHLIST_ROUTE } from "../../../routes/web/rootRoutes";
import { IoClose } from "react-icons/io5";

const WishlistDropdown = ({ products, loading, onClose }) => {
  const [closing, setClosing] = useState(false);

  const handleClose = () => {
    setClosing(true);
    setTimeout(() => onClose(), 350);
  };

  const count = loading ? 0 : (products?.products?.length ?? 0);

  return (
    <>
      <div
        className={`fixed inset-0  h-[100vh]  bg-black/60 backdrop-blur-sm z-[500] transition-opacity duration-300 ${
          closing ? "opacity-0" : "opacity-100"
        }`}
        onClick={handleClose}
      ></div>

      <div
        className={`wishlist-drawer ${
          closing ? "animate-slide-right" : "animate-slide-left"
        }`}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b shadow-sm">
          <h4 className="font-semibold text-lg">
            My Wishlist ({count})
          </h4>

          <button
            onClick={handleClose}
            className="p-2 rounded-full hover:bg-gray-200 transition"
          >
            <IoClose className="text-2xl text-gray-600 hover:text-black transition" />
          </button>
        </div>

        {/* Wishlist items / Empty state */}
        <div className="flex-1 overflow-y-auto px-4 py-3 scrollbar-thin scrollbar-track-gray-200 scrollbar-thumb-gray-400">

          {loading ? (
            <div className="animate-pulse">
              <div className="h-12 bg-gray-200 rounded mb-2" />
              <div className="h-12 bg-gray-200 rounded mb-2" />
              <div className="h-12 bg-gray-200 rounded mb-2" />
            </div>
          ) : count === 0 ? (
            <div className="flex flex-col items-center justify-center h-full text-center py-10">
              <span className="text-6xl mb-4">💖</span>
              <p className="text-lg font-semibold text-gray-700">No Wishlist Items</p>
              <p className="text-gray-500 text-sm mt-1">
                Add products to wishlist to save them
              </p>
            </div>
          ) : (
            <WishlistList cartItems={products?.products ?? []} loading={loading} />
          )}

        </div>

        {/* Footer */}
        <div className="p-4 border-t bg-gray-100">
          <Link
            to={count === 0 ? "#" : WISHLIST_ROUTE}
            onClick={count === 0 ? (e) => e.preventDefault() : handleClose}
            className={`w-full block text-center py-3 rounded-xl font-semibold transition ${
              count === 0
                ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                : "bg-green-800 text-white hover:bg-green-800"
            }`}
          >
            Go To Wishlist
          </Link>
        </div>
      </div>

      <style>{`
        .wishlist-drawer {
          position: fixed;
          top: 0px;
          right: 0;
          height: 100vh;
          background: #ffffff;
          width: 85%;
          max-width: 400px;
          z-index: 700;
          box-shadow: -4px 0 20px rgba(0,0,0,0.2);
          display: flex;
          flex-direction: column;
          transform: translateX(100%);
        }

        @media (min-width: 768px) {
          .wishlist-drawer {
            width: 380px;
          }
        }

        @keyframes slideLeft {
          from { transform: translateX(100%); }
          to   { transform: translateX(0); }
        }

        @keyframes slideRight {
          from { transform: translateX(0); }
          to   { transform: translateX(100%); }
        }

        .animate-slide-left { animation: slideLeft 0.35s ease-out forwards; }
        .animate-slide-right { animation: slideRight 0.35s ease-in forwards; }

        .scrollbar-thin::-webkit-scrollbar { width: 6px; }
        .scrollbar-thin::-webkit-scrollbar-thumb {
          background: #aaa;
          border-radius: 20px;
        }
      `}</style>
    </>
  );
};

export default WishlistDropdown;
